import http from '@/plugins/api'
import * as types from './types'
import globals from '@/plugins/globals.js'
import {
  startLoading
} from '@/plugins/loading'

export default {
  // initSendBird({ commit }, apiId) {
  //   commit(types.INIT_SENDBIRD, apiId)
  // },
  resetMessageList({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  addMessageToList({ commit }, message, hasmore) {
    commit(types.ADD_MESSAGE, message, hasmore)
  },
  addAttachmentToMessageList({ commit }, message, hasmore) {
    commit(types.ADD_ATTACHMENT_MESSAGE, message, hasmore)
  },
  setTyping({ commit }, channel) {
    commit(types.SET_TYPING, channel)
  },
  resetChatMessages({ commit }) {
    commit(types.RESET_CHAT_MESSAGES)
  },
  async loadChatHistory({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'loadChatHistory', () =>
      http.get(`Message/ServiceRequestMessages?id=${id}&language=en`)
    )
    commit(types.SET_CHAT_MESSAGES, r.data)
    return r.data
  },
  async getMessageCounts({ commit, dispatch }, data) {
    if (data.workOrderId === undefined || data.workOrderId === null) {
      data.workOrderId = ''
    }
    if (data.email === undefined || data.email === null) {
      data.email = globals.email
    }
    const r = await startLoading(dispatch, 'getMessageCounts', () =>
      http.get(`Message/DirectUserMessageCount/?username=${data.email}&workOrderId=${data.workOrderId}&operatorname=`)
    )
    commit(types.SET_MESSAGECOUNTS, r.data)
  },
  resetChannels({ commit }) {
    commit(types.RESET_CHANNELS)
  },
  async getUserChannels({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getUserChannels', () =>
      http.get(`chat/SendBirdUserChannels?userid=${encodeURIComponent(options.userid)}&token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}`)
    )
    commit(types.SET_CHANNELS, r.data)
  },
  async syncApps({ dispatch }, message) {
    const r = await startLoading(dispatch, 'syncApps', () =>
      http.post('Message/SyncApps', message)
    )
    return r.data
  },
  async audit({ dispatch }, message) {
    if (globals.isSendbirdAuditingEnabled()) {
      const r = await startLoading(dispatch, 'audit', () =>
        http.post('Sendbird/Audit', message)
      )
      return r.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js